import { render, staticRenderFns } from "./Guide.vue?vue&type=template&id=4cef8d82&scoped=true"
import script from "./Guide.vue?vue&type=script&lang=js"
export * from "./Guide.vue?vue&type=script&lang=js"
import style0 from "./Guide.vue?vue&type=style&index=0&id=4cef8d82&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef8d82",
  null
  
)

export default component.exports